import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Global error tracker
const logError = (type, message, stack = "", action = "") => {
  try {
    const userEmail = localStorage.getItem("user_email") || "";
    axios.post(`${API}/log/error`, {
      type,
      message: String(message).substring(0, 500),
      stack: String(stack).substring(0, 1000),
      url: window.location.href,
      user_email: userEmail,
      action,
    }).catch(() => {});
  } catch {}
};

// Catch unhandled JS errors
window.onerror = (message, source, lineno, colno, error) => {
  logError("unhandled_error", `${message} at ${source}:${lineno}:${colno}`, error?.stack, "window.onerror");
};

// Catch unhandled promise rejections
window.onunhandledrejection = (event) => {
  logError("unhandled_rejection", event.reason?.message || String(event.reason), event.reason?.stack, "promise_rejection");
};

// Axios global error interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status >= 500) {
      logError("api_error", `${error.config?.method?.toUpperCase()} ${error.config?.url} -> ${error.response.status}`, error.response?.data?.detail || "", "api_call");
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
